import React, { useState } from "react";
import Slider from "react-slick";
import { Box, Typography } from "@mui/material";
import { useNavigate } from 'react-router-dom';

// Import CSS for the slider
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./carousel.css";


const PrevArrow = ({ onClick }) => (
  <Box
    onClick={onClick}
    className="prev-arrow"
    sx={{
      position: "absolute",
      top: "50%",
      transform: "translateY(-50%)",
      zIndex: 2,
      cursor: "pointer"
    }}
  >
    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="18" viewBox="0 0 15 18" fill="none">
      <path d="M0.5 9.5L14 1L9 9L14 17.5L0.5 9.5Z" stroke="#E4535F" strokeLinejoin="round"/>
    </svg>
  </Box>
);

const NextArrow = ({ onClick }) => (
  <Box
    onClick={onClick}
    className="next-arrow"
    sx={{
      position: "absolute",
      right: "-30px",
      top: "50%",
      transform: "translateY(-50%)",
      zIndex: 2,
      cursor: "pointer"
    }}
  >
    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="18" viewBox="0 0 15 18" fill="none">
      <path d="M14.5 8.5L1 17L6 9L1 0.5L14.5 8.5Z" stroke="#E4535F" strokeLinejoin="round"/>
    </svg>
  </Box>
);

function Carousel({ images, customClass = '', slidesToShow }) {
  const [currentSlide, setCurrentSlide] = useState(0);
  const navigate = useNavigate();
  const settings = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: slidesToShow,
    slidesToScroll: 1,
    arrows: true,
    prevArrow: <PrevArrow />,
    nextArrow: <NextArrow />,
    centerMode: false,
    autoplay: false,
    autoplaySpeed: 4000,
    centerPadding: "60px",
    focusOnSelect: true,
    beforeChange: (current, next) => setCurrentSlide(next),
    responsive: [
      {
        breakpoint: 1000, // Tablet
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 480, // Mobile
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  const handleClick = ({ index, path }) => {
    if (index === currentSlide) {
      // Navigates to the path only when user cicks on centered slide
      navigate(path);
    }
  };

  return (
    <Box className={`carousel ${customClass}`} sx={{ backgroundColor: "#00000000" }}>
      <Slider {...settings}>
        {images.map((image, index) => {
          const slideClass = ""
          return (
            <Box key={index} className={slideClass}>
              <img
                src={image.src}
                alt={`Slide ${index}`}
                className="carousel-image"
                onClick={() => handleClick({ index, path: image.route })}
              />
              <Typography
                variant="h3"
                align="center"
                className="caption-slide"
                sx={{ color: "#fff", marginTop: 2 }}
              >
                {image.caption}
              </Typography>
            </Box>
          );
        })}
      </Slider>
    </Box>
  );
}

export default Carousel;
